/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { BrandingsShowPathParams, BrandingsShowResponse } from '../types/BrandingsShow'

/**
 * GET /brandings/:branding
 * @see backend/nexus/modules/Branding/Http/Controllers/BrandingController.php BrandingController::show
 */
export async function brandingsShow(
	branding: BrandingsShowPathParams['branding'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<BrandingsShowResponse>> {
	return axiosInstance.get(`/brandings/${branding}`, config)
}
